import {
  SET_SHOW_LOGO,
  SET_SHOW_ARTWORK_DETAILS,
  SET_SWITCH_ARTWORK,
  SET_4K_QUALITY,
  SET_MUTE,
  QR,
  MATCHCONTENT,
  FILL_SCREEN,
  RANDOMISE,
} from '../constants/settingContants';

const initialState = { showLogo: true, showArtworkDetails: true, switchArtwork: true, quality4k: true, mute: false, qr: false, fillScreen: false, randomise: false};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_LOGO:
      return { ...state, showLogo: action.payload };
    case SET_SHOW_ARTWORK_DETAILS:
      return { ...state, showArtworkDetails: action.payload };
    case SET_SWITCH_ARTWORK:
      return { ...state, switchArtwork: action.payload };
    case SET_4K_QUALITY:
      return { ...state, quality4k: action.payload };
    case SET_MUTE:
      return { ...state, mute: action.payload };
    case QR:
      return { ...state, qr: action.payload };
    case MATCHCONTENT:
      return { ...state, matchContent: action.payload };
    case FILL_SCREEN:
      return { ...state, fillScreen: action.payload };
    case RANDOMISE:
      return { ...state, randomise: action.payload };
    default:
      return state;
  }
};

export default reducer;
